module.exports = __webpack_public_path__ + "static/media/grains_2.7800017f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/grains/grains_2.csv
// module id = 730
// module chunks = 0